<script setup lang="ts">
// Overrides @basecom-gmbh/pond/components/Cookie/CookieBanner.vue
const cookieBannerStore = useCookieBannerStore();
const analyticsStore = useAnalytics();
const { showCookieBanner, activatedCookies } = storeToRefs(cookieBannerStore);

cookieBannerStore.$onAction(({ name, after }) => {
    const actionsThatUpdateCookies = ['updateCookies', 'denyAll', 'acceptAll', 'initializeCookies'];
    if (!actionsThatUpdateCookies.includes(name)) return;

    after(() => {
        analyticsStore.updateConsent(activatedCookies.value);
    });
});

cookieBannerStore.initializeCookies();
</script>

<template>
    <div
        v-if="showCookieBanner"
        class="bg-white pointer-events-auto fixed bottom-0 z-50 flex w-full border-t-2 border-gray-dark p-2 text-xs md:flex-col"
    >
        <div class="container mx-auto flex flex-col items-center justify-between gap-4 text-center md:flex-row">
            <CookieBannerMessage />
            <CookieBannerActions />
        </div>
    </div>
</template>
